export const DEMO_INVOICE_NUMBER = 1
export const DEMO_INVOICE_NUMBER_PREFIX = 'DEMO'
